<template>
    <div v-if="is_active">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String,
                default: null,
            },

            href: {
                type: String,
                default: null
            },

            id: {
                type: Number,
                default: 0
            },

            name: {
                type: String,
                required: true
            },

            selected: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                is_active: this.selected,
                current_name: this.name,
            }
        },

        mounted() {
            this.is_active = this.selected
        }
    }
</script>
